// extracted by mini-css-extract-plugin
export default {"main":"bad6e29fdb","tit":"fa94ee6927","maintitle":"f58b45b40a","ylw":"d00b8c31d3","white":"_24f3ae37c3","mv_title":"_45e99e18ad","mv_nc":"a959c4b70d","mv_in":"df2353557f"};